import React from 'react';

const DownloadApp = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  if (/android/i.test(userAgent)) {
    window.open("https://play.google.com/store/apps/details?id=com.nubes.parkhive_hiver", "_blank");
  } else if (/iPad|iPhone|iPod/.test(userAgent)) {
    window.open("https://apps.apple.com/in/app/park-hive-hiver/id6479428699", "_blank");
  }
  return (
    <div id="download" className="min-h-screen flex flex-col items-center justify-center bg-gray-100 text-gray-900">
      <h1 className="text-3xl font-bold mb-4">Download Our App</h1>
      <p className="text-lg mb-6">Get the app for the best experience!</p>
      
      {/* Play Store Link */}
      <a
        href="https://play.google.com/store/apps/details?id=com.nubes.parkhive_hiver"
        target="_blank"
        rel="noopener noreferrer"
        className="px-6 py-3 bg-green-600 text-white rounded hover:bg-green-700 mb-4"
      >
        Download on Play Store
      </a>

      {/* App Store Link */}
      <a
        href="https://apps.apple.com/in/app/park-hive-hiver/id6479428699"
        target="_blank"
        rel="noopener noreferrer"
        className="px-6 py-3 bg-blue-600 text-white rounded hover:bg-blue-700"
      >
        Download on App Store
      </a>
    </div>
  );
};

export default DownloadApp;